import { NgModule } from '@angular/core';
import { RouterModule, Routes, mapToCanActivate } from '@angular/router';
import { EstimateGeneralSettingsComponent } from '@app-settings/estimate-general/estimate-general-settings.component';
import { EstimateInterfaceSettingsComponent } from '@app-settings/estimate-interface/estimate-interface-settings.component';
import { ServicesLicensesSettingsComponent } from '@app-settings/services-licenses/services-licenses-settings.component';
import { SettingsOverrideComponent } from '@app-settings/settings-override/settings-override.component';
import { SettingsComponent } from '@app-settings/settings.component';
import { AppContainerComponent } from '@core/components/app-container/app-container.component';
import { LicenseExpiredComponent } from '@core/error-page/license-expired/license-expired.component';
import { UnauthorizedAccessComponent } from '@core/error-page/unauthorized-access/unauthorized-access.component';
import { UserLockedComponent } from '@core/error-page/user-locked/user-locked.component';
import { LandingPageComponent } from '@core/landing-page/landing-page.component';
import { DataManagmentComponent } from '@data-managment/data-managment.component';
import { EstimateComponent } from '@estimate/estimate.component';
import { EstimateListComponent } from '@estimate/list/estimate-list.component';
import { ClassModalComponent } from '@estimate/toolbar/class-modal/class-modal.component';
import { DepartmentModalComponent } from '@estimate/toolbar/department-modal/department-modal.component';
import { InternalResourceModalComponent } from '@estimate/toolbar/internal-resources-modal/internal-resources-modal.component';
import { PropertiesModalComponent } from '@estimate/toolbar/properties-modal/properties-modal.component';
import { ImportModalComponent } from '@estimate/toolbar/structure-modal/import-modal/import-modal.component';
import { StructureModalComponent } from '@estimate/toolbar/structure-modal/structure-modal.component';
import { LogoutComponent } from '@shared/pages/logout/logout.component';
import { PageNotFoundComponent } from '@shared/pages/page-not-found/page-not-found.component';
import { UnauthorizedComponent } from '@shared/pages/unauthorized/unauthorized.component';
import { AuthGuard } from '@shared/services/auth.guard';
import { EstimateListGuard } from '@shared/services/estimate-list.guard';
import { LegacyRoutesGuard } from '@shared/services/legacy-routes.guard';
import { LicenseGuard } from '@shared/services/license.guard';
import { LicenseAppModule } from '@shared/services/license.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full'
  },
  {
    path: '401',
    component: UnauthorizedComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: '404',
    component: PageNotFoundComponent
  },
  {
    path: 'user-locked',
    component: UserLockedComponent
  },
  {
    path: 'license-expired',
    component: LicenseExpiredComponent
  },
  {
    path: 'unauthorized',
    component: UnauthorizedAccessComponent
  },
  //legacy redirect.
  {
    path: 'client',
    children: [
      {
        path: '**',
        component: LandingPageComponent,
        canActivate: mapToCanActivate([LegacyRoutesGuard])
      }
    ]
  },
  //legacy redirect.
  {
    path: 'eap-angular',
    children: [
      {
        path: '**',
        component: LandingPageComponent,
        canActivate: mapToCanActivate([LegacyRoutesGuard])
      }
    ]
  },
  {
    path: 'app',
    component: AppContainerComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    children: [
      {
        path: 'welcome',
        component: LandingPageComponent
      },

      {
        path: 'estimate-list',
        component: EstimateListComponent,
        canActivate: [...mapToCanActivate([LicenseGuard]), EstimateListGuard],
        data: { appModule: LicenseAppModule.Estimation }
      },
      {
        path: 'estimate-detail/:id',
        component: EstimateComponent,
        canActivate: mapToCanActivate([LicenseGuard]),
        data: { appModule: LicenseAppModule.Estimation },
        children: [
          {
            path: 'properties',
            component: PropertiesModalComponent
          },
          {
            path: 'structure',
            component: StructureModalComponent,
            children: [
              {
                path: 'import',
                component: ImportModalComponent
              }
            ]
          },
          {
            path: 'department',
            component: DepartmentModalComponent
          },
          {
            path: 'class',
            component: ClassModalComponent
          },
          {
            path: 'internal-resources',
            component: InternalResourceModalComponent
          }
        ]
      },
      {
        path: 'data-management',
        component: DataManagmentComponent,
        canActivate: mapToCanActivate([LicenseGuard])
      },

      {
        path: 'settings-override',
        component: SettingsOverrideComponent
      },
      {
        path: 'settings-management',
        component: SettingsComponent,
        children: [
          {
            path: 'estimate',
            component: EstimateGeneralSettingsComponent,
            canActivate: mapToCanActivate([LicenseGuard]),
            data: { appModule: LicenseAppModule.Estimation, checkUserAccess: false }
          },
          {
            path: 'estimate-interface',
            component: EstimateInterfaceSettingsComponent,
            canActivate: mapToCanActivate([LicenseGuard]),
            data: { appModule: LicenseAppModule.Estimation, checkUserAccess: false }
          },
          {
            path: 'license',
            component: ServicesLicensesSettingsComponent
          },
          {
            path: '',
            redirectTo: 'estimate',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: '',
        redirectTo: 'welcome',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      //enableTracing: true //<-- Use this when debugging the router
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
